// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCustomerProfileApplicationStateControllerGetAllData } from './PublicCustomerProfileApplicationStateControllerGetAllData.gen';
import type { PublicCustomerProfileApplicationStateControllerGetAllErrors } from './PublicCustomerProfileApplicationStateControllerGetAllErrors.gen';
import type { PublicCustomerProfileApplicationStateControllerGetAllResponses } from './PublicCustomerProfileApplicationStateControllerGetAllResponses.gen';

export class PublicCustomerProfileApplicationStateController {
    /**
     * Get customer profile request possible states
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicCustomerProfileApplicationStateControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCustomerProfileApplicationStateControllerGetAllResponses, PublicCustomerProfileApplicationStateControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customer-profile-application-states',
            ...options
        });
    }
}
